import React from 'react';
import {Navigate, useLocation, Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';

const UserIsAuthenticated = () => {
    const location = useLocation();
    const userProfileData = useSelector((state) => state.UserReducer.userProfileData);
    const userIsConnected = useSelector((state) => state.UserReducer.userIsConnected);

    const useAuth = () => {
        // Vérifier à la fois la présence des données et le statut de connexion
        return userProfileData && userIsConnected !== false;
    };

    const isAuthenticated = useAuth();

    return isAuthenticated ? <Outlet/> : <Navigate to="/login" state={{from: location}} replace/>;
};

export default UserIsAuthenticated;
